import { PageTransition } from './PageTransition'
import { Heading } from '@/components/ui/typography'

export function PageHeader({ title }: { title: string; subtitle?: string }) {
  return (
    <PageTransition>
      <div className="flex flex-col gap-1">
        <Heading variant="subsection-title">{title}</Heading>
      </div>
    </PageTransition>
  )
}
